"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyCodes = void 0;
exports.keyCodes = {
    escape: 27,
    backspace: 8,
    tab: 9,
    space: 32,
    k: 75,
    enter: 13,
    upArrow: 38,
    downArrow: 40,
    shift: 16
};
//# sourceMappingURL=key-codes.js.map